module.exports = __webpack_public_path__ + "images/sort-up-hover-white-2f73c7fc.svg";